import { isDefined, isNonEmptyString } from 'ts-utils';
import { AppSelector, store } from '../store/Store';
import { getASLClinicSearchParam } from './AssessmentUtils';

/** @throws if asl query string is undefined or invalid */
export function getAslPaymentLink(): string {
  const { userId, email } = AppSelector.user(store.getState());
  const paymentLinkId = getASLClinicSearchParam();

  if (!isDefined(userId)) {
    throw new Error('userId not defined for ASL payment link');
  }
  if (!isNonEmptyString(paymentLinkId)) {
    throw new Error('paymentLinkId is undefined or empty for ASL payment link');
  }

  return `https://buy.stripe.com/${paymentLinkId}?client_reference_id=${userId}&locked_prefilled_email=${email}`;
}
